module.exports = __webpack_public_path__ + "img/mini-fridge.b079b0ea.svg";